import React from 'react';

const SvgTravel = (props) => (
  <svg width={24} height={24} viewBox="-2 -2 21 21" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.144.819c.397-.23.883-.242 1.289-.033l6.852 3.524 3.8-1.943a1.475 1.475 0 0 1 1.95.57 1.402 1.402 0 0 1-.518 1.914l-3.69 2.13-.27 7.893a1.324 1.324 0 0 1-.663 1.1.569.569 0 0 1-.832-.337L9.236 9.055l-3.77 2.177.262 2.71a.668.668 0 0 1-.331.642.43.43 0 0 1-.587-.155L.775 7.44a.393.393 0 0 1 .138-.533.593.593 0 0 1 .645.018L3.924 8.56l3.77-2.177-4.67-4.679a.562.562 0 0 1 .12-.885z"
    />
  </svg>
);

export default SvgTravel;
